import { render, staticRenderFns } from "./ComercialesTableSingleStats.vue?vue&type=template&id=859b4db2&"
import script from "./ComercialesTableSingleStats.vue?vue&type=script&lang=js&"
export * from "./ComercialesTableSingleStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
